export default __webpack_public_path__ + "static/media/goods7.1dbfe197.gif";